import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGlobe = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 13,
	height: 13,
	viewBox: "0 0 13 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.5 0.5C8.00077 2.14301 8.85365 4.27522 8.9 6.5C8.85365 8.72478 8.00077 10.857 6.5 12.5M6.5 0.5C4.99923 2.14301 4.14635 4.27522 4.1 6.5C4.14635 8.72478 4.99923 10.857 6.5 12.5M6.5 0.5C3.18629 0.5 0.5 3.18629 0.5 6.5C0.5 9.81371 3.18629 12.5 6.5 12.5M6.5 0.5C9.81371 0.5 12.5 3.18629 12.5 6.5C12.5 9.81371 9.81371 12.5 6.5 12.5M0.800012 4.7H12.2M0.8 8.3H12.2",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgGlobe;
